import React from "react"
import {connect} from 'react-redux'
import Typography from '@material-ui/core/Typography'
import * as cornerstone from "cornerstone-core"
import * as cornerstoneFileImageLoader from "cornerstone-file-image-loader"
import * as cornerstoneWADOImageLoader from "cornerstone-wado-image-loader"
import {uids} from '../constants/uids'
import CircularProgress from '@material-ui/core/CircularProgress'

import {
  clearStore, 
  dcmIsOpen, 
  activeDcm, 
  dcmTool, 
  activeMeasurements,
  doFsRefresh,
  setDcmEnableTool,
} from '../actions'

import {
  isFileImage,
  isFsFileImage,
  isUrlImage,
} from '../functions'
import { ensureImageRender, canUseWebImageRender, applyNeutralWebPreviewVoi } from '../utils/ensureImageRender'
import { lockCornerstoneCanvasContext } from '../utils/patchCanvasNoDesync'

class DicomPreviewer extends React.Component {
    constructor(props) {
      super(props)
      this.files = null
      this.filename = ''
      this.localfile = null
      this.localurl = null
      this.fsItem = null
      this.dicomImage = null
      this.explorerIndex = 0
      this.imageId = null
      this.image = null
      this.isDicom = false
      this.numberOfFrames = 1
      this.measurements = []
      this.originImage = null
      this.mprPlane = ''
      this.sliceMax = 0
      this.sliceIndex = 0
      this.shouldScroll = false
      this._miniatureLoaded = false
    }

    state = {
      visibleOpenUrlDlg: false,
      progress: null,
      visibleCinePlayer: false,
      errorOnOpenImage: null,
      errorOnCors: false,
      frame: 1,
      inPlay: false,
      viewport: null,
    }

    componentDidMount() {
      this.props.runTool(this)
      const { dcmRef } = this.props
      dcmRef(this)
      this._miniatureLoaded = false
    }

    componentWillUnmount() {
      this.props.runTool(undefined)
      const { dcmRef } = this.props
      dcmRef(undefined)
      this._miniatureLoaded = false
    }

    componentDidUpdate(previousProps) {
      //console.log('dicomviewer - componentDidUpdate: ')
    }

    onOpenUrl = (e) => {
      const eventData = e.detail
      this.setState({ progress: eventData.percentComplete })
    }

    showOpenUrlDlg = (url) => {
      this.setState({ visibleOpenUrlDlg: true }, () => {
        cornerstone.events.addEventListener('cornerstoneimageloadprogress', this.onOpenUrl)
        this.loadImage(undefined, url)
      })
    }
  
    hideOpenUrlDlg = () => {
      this.setState({ visibleOpenUrlDlg: false, progress: null })
    }

    measurementSave = (measure) => {
      this.measurements.push(measure) 
    }

    measurementClear = () => {
      this.measurements.splice(0, this.measurements.length)
    }

    measurementRemove = (index) => {
      this.measurements.splice(index, 1)
    }    

    getTransferSyntax = () => {
      const value = this.image.data.string('x00020010')
      return value + ' [' + uids[value] + ']'
    }

    getSopClass = () => {
      const value = this.image.data.string('x00080016')
      return value + ' [' + uids[value] + ']'
    }

    getSopInstanceUID = () => {
      const value = this.image.data.string('x00080018')
      return value
    }

    getPixelRepresentation = () => {
      const value = this.image.data.uint16('x00280103')
      if (value === undefined) return
      return value + (value === 0 ? ' (unsigned)' : ' (signed)')
    }

    getPlanarConfiguration = () => {
      const value = this.image.data.uint16('x00280006')
      if (value === undefined) return 
      return value + (value === 0 ? ' (pixel)' : ' (plane)')
    }

    getDicomViewerElement = () => {
      return document.getElementsByClassName('cornerstone-enabled-image')
    }
   
    onImageLoaded = (e) => {
      //console.log('cornerstoneimageloaded: ')
    }

    // Listen for changes to the viewport so we can update the text overlays in the corner
    onImageRendered = (e) => {
      if (!this._miniatureLoaded && typeof this.props.onLoadedImage === 'function') {
        this._miniatureLoaded = true
        this.props.onLoadedImage()
      }
      if (this.isDicom && this.state.visibleCinePlayer && this.numberOfFrames > 1) {
        document.getElementById(
          `frameLabel-${this.props.index}`
        ).textContent = `${this.state.frame} / ${this.numberOfFrames}`
        if (this.state.inPlay) {
          let frame = this.state.frame === this.numberOfFrames ? 1 : this.state.frame+1
          this.setState({frame: frame})
        }
      }
    }

    onErrorOpenImageClose = () => {
      this.setState({errorOnOpenImage: null})
    }

    onErrorCorsClose = () => {
      this.setState({errorOnCors: false})
    }    

    updateImage = () => {
      const element = this.dicomImage
      cornerstone.updateImage(element)
    }

    displayImageFromFiles = (index) => {
      const files = this.files === null ? this.props.files : this.files
      
      if (!files || !files[index] || !files[index].image) {
        console.log('DicomPreviewer - No image data available yet')
        return
      }

      const image = files[index].image
      const imageId = files[index].imageId
      const fileData = files[index]
      this.filename = files[index].name

      const element = this.dicomImage
      if (!element) {
        console.log('DicomPreviewer - No element available')
        return
      }

      element.addEventListener("cornerstonenewimage", this.onNewImage)
      element.addEventListener("cornerstoneimagerendered", this.onImageRendered)

      try {
        cornerstone.enable(element)
      } catch (e) {
        // already enabled
      }
      lockCornerstoneCanvasContext(element)

      this.image = image
      // Preview web solo si getImage; DICOM (incl. color) usa path nativo
      ensureImageRender(image, fileData)
      const isWeb = canUseWebImageRender(image)
      const isPreview =
        isWeb ||
        ((fileData && fileData.renderKind === 'preview') && !(image && image.data))
      this.isDicom = !isPreview
      
      try {
        if (isWeb) {
          this.PatientsName =
            (fileData.patient && fileData.patient.patientName) || ''
          this.sopInstanceUid = fileData.sopInstanceUID || null
          this.numberOfFrames = 0
          const viewport = cornerstone.getDefaultViewportForImage(element, image)
          if (viewport.voi) {
            applyNeutralWebPreviewVoi(viewport)
          }
          cornerstone.displayImage(element, image, viewport)
        } else {
          this.PatientsName = image.data.string('x00100010')
          this.sopInstanceUid = this.getSopInstanceUID()

          let stack = { currentImageIdIndex: 0, imageIds: "" }
          this.numberOfFrames = image.data.intString('x00280008')
          if (this.numberOfFrames > 0) {
            let imageIds = []	
            for(var i=0; i < this.numberOfFrames; ++i) {
              imageIds.push(imageId + "?frame="+i)
            }	
            stack.imageIds = imageIds
          }

          cornerstone.displayImage(element, image)
        }
        if (typeof this.props.onLoadedImage === 'function') {
          this.props.onLoadedImage()
        }
      } catch (error) {
        console.error('DicomPreviewer - Error displaying image:', error)
      }
      this._miniatureLoaded = false
    }

    loadImage = (localfile, url=undefined, fsItem=undefined) => {

      if (localfile === undefined && url === undefined && fsItem === undefined) return
      
      if (fsItem !== undefined) {
        this.fsItem = fsItem
      } else if (localfile !== undefined) {
        this.localfile = localfile
      } else {
        this.localurl = url
      }
 
      const element = this.dicomImage

      element.addEventListener("cornerstonenewimage", this.onNewImage)
      element.addEventListener("cornerstoneimagerendered", this.onImageRendered)
      element.addEventListener("cornerstonetoolsmeasurementadded", this.onMeasurementAdded)
      element.addEventListener("cornerstonetoolsmeasurementmodified", this.onMeasurementModified)
      element.addEventListener("cornerstonetoolsmeasurementcompleted", this.onMeasurementCompleted)

      let imageId = undefined

      cornerstone.enable(element)
      lockCornerstoneCanvasContext(element)

      if (localfile === undefined && isUrlImage(url)) { // check if it's a simple image [jpeg or png] from url

        cornerstone.loadImage(url).then(image => {
          this.hideOpenUrlDlg()

          this.image = image

          this.isDicom = false

          cornerstone.displayImage(element, image)
          
          this.enableTool()

          this.props.setActiveDcm({image: this.image, element: this.dicomImage, isDicom: this.isDicom})
          this.props.isOpenStore(true)
          if (typeof this.props.onLoadedImage === 'function') {
            this.props.onLoadedImage()
          }

        }, (e) => {
          console.log('error', e)
          this.setState({errorOnOpenImage: "This is not a valid JPG or PNG file."})
        })

      } else if ((localfile !== undefined && isFileImage(localfile)) || (fsItem !== undefined && isFsFileImage(fsItem))) { // otherwise try to open as local image file (JPEG, PNG) 
        if (fsItem !== undefined) {
          imageId = cornerstoneFileImageLoader.fileManager.addBuffer(fsItem.data)
        } else {
          imageId = cornerstoneFileImageLoader.fileManager.add(localfile)
        }
        cornerstone.loadImage(imageId).then(image => {
          console.log('loadImage, image from local: ', image)

          this.image = image
          this.isDicom = false
          this.PatientsName = ''

          cornerstone.displayImage(element, image)
          
          this.enableTool()

          this.props.setActiveDcm({image: this.image, element: this.dicomImage, isDicom: this.isDicom})

          this.props.setIsOpenStore({index: this.props.index, value: true})
          if (typeof this.props.onLoadedImage === 'function') {
            this.props.onLoadedImage()
          }

        }, (e) => {
          console.log('error', e)
          this.setState({errorOnOpenImage: "This is not a valid JPG or PNG file."})
        })

      } else { // otherwise try to open as Dicom file

        if (fsItem !== undefined) {
          imageId = cornerstoneWADOImageLoader.wadouri.fileManager.addBuffer(fsItem.data)
          this.filename = fsItem.name
          //size = fsItem.size
        } else if (localfile !== undefined) {
          imageId = cornerstoneWADOImageLoader.wadouri.fileManager.add(localfile)
          this.filename = localfile.name
          //size = localfile.size
        } else { // it's a web dicom image
          imageId = "wadouri:"+url
        }

        cornerstone.loadAndCacheImage(imageId).then(image => {
          
          this.hideOpenUrlDlg()

          this.image = image

          this.isDicom = true

          this.PatientsName = image.data.string('x00100010')
          this.sopInstanceUid = this.getSopInstanceUID()

          let stack = { currentImageIdIndex: 0, imageIds: "" }
          this.numberOfFrames = image.data.intString('x00280008')
          if (this.numberOfFrames > 0) {
            let imageIds = []	
            for(var i=0; i < this.numberOfFrames; ++i) {
              imageIds.push(imageId + "?frame="+i)
            }	
            stack.imageIds = imageIds
          }

          cornerstone.displayImage(element, image)

          this.enableTool()
          if (typeof this.props.onLoadedImage === 'function') {
            this.props.onLoadedImage()
          }

        }, (e) => {
          console.log('error', e)   
          this.hideOpenUrlDlg()      
          //console.log('toString: ', e.error.toString())
          const error = e.error.toString()
          if (error === '[object XMLHttpRequest]') {
            this.setState({errorOnCors: true})
          } else {
            const pos = error.indexOf(":")
            this.setState({errorOnOpenImage: pos < 0 ? e.error : error.substring(pos+1)})            
          } 
        })
      }
    }

    runTool = (toolName, opt) => {
      if (this.state.inPlay) {
        this.runCinePlayer('pause')
      }
      switch (toolName) {
        case 'setfiles': {
          this.files = opt
          this.sliceMax = this.files.length
          this.shouldScroll = this.files.length > 1
          this._miniatureLoaded = false
          break   
        }        
        case 'openimage': {
          cornerstone.disable(this.dicomImage)
          this.sliceIndex = opt
          this._miniatureLoaded = false
          this.displayImageFromFiles(opt)
          break   
        }

        case 'reset': {
          this.reset()
          break
        }

        case 'clear': {
          this.files = null
          cornerstone.disable(this.dicomImage)
          break
        }  
  
        default: {
          break
        }
      }
    } 

    reset = () => {
      const element = this.dicomImage
      const defaultViewport = cornerstone.getDefaultViewportForImage(element, this.image)
      let viewport = cornerstone.getViewport(element)
      viewport.voi.windowWidth = defaultViewport.voi.windowWidth
      viewport.voi.windowCenter = defaultViewport.voi.windowCenter
      viewport.invert = false
      cornerstone.setViewport(element, viewport)
    }

    dicomImageRef = el => {
      this.dicomImage = el
    }

    onImageClick = () => {
      //console.log('onImageClick: ')
    }

    getSeriesNumber = () => {
      if (this.props.series === undefined || this.props.series === null) return
      if (!this.props.series.seriesList || !this.props.series.seriesKeys) return
      const seriesKey = this.props.series.seriesKeys[this.props.index]
      if (!seriesKey) return
      const seriesData = this.props.series.seriesList.get(seriesKey)
      if (!seriesData || !seriesData[this.props.index]) return
      return seriesData[this.props.index].series?.seriesNumber
    }

    getSeriesLength = () => {
      if (this.props.series === undefined || this.props.series === null) return
      if (!this.props.series.seriesList || !this.props.series.seriesKeys) return
      const seriesKey = this.props.series.seriesKeys[this.props.index]
      if (!seriesKey) return
      const seriesData = this.props.series.seriesList.get(seriesKey)
      if (!seriesData) return
      return seriesData.length
    }

    getSeriesDescription = () => {
      if (this.props.series === undefined || this.props.series === null) return
      if (!this.props.series.seriesList || !this.props.series.seriesKeys) return
      const seriesKey = this.props.series.seriesKeys[this.props.index]
      if (!seriesKey) return
      const seriesData = this.props.series.seriesList.get(seriesKey)
      if (!seriesData || !seriesData[this.props.index]) return
      return seriesData[this.props.index].series?.seriesDescription
    }

    render() {
        const { isMobile } = this.props
        const errorOnOpenImage = this.state.errorOnOpenImage
        const progress = this.state.progress
        
        this.sliceMax = this.getSeriesLength()

        const styleContainer = {
            width: '100%', 
            height: '100%', 
            border: (this.props.explorerActiveSeriesIndex === this.props.index) ? 'solid 1px #AAAAAA' : null,
            position: 'relative',
            ...(isMobile ? {
                height: '80px',
                minHeight: '80px',
                maxHeight: '80px',
            } : {})
        }

        const styleDicomImage = {
            width: '100%', 
            height: '100%', 
            position: 'relative',
            ...(isMobile ? {
                height: '80px',
                minHeight: '80px',
                maxHeight: '80px',
            } : {})
        }

        return (
            <div style={styleContainer}>
                <div 
                    ref={this.dicomImageRef}
                    style={styleDicomImage}
                    onClick={this.onImageClick}
                    className="cornerstone-enabled-image"
                />
                {/* Contador de imagen actual para miniaturas */}
                {this.sliceMax > 0 && (
                    <div style={{
                        position: 'absolute',
                        top: 2,
                        right: 2,
                        color: '#4caf50',
                        fontSize: '0.7em',
                        fontWeight: '600',
                        textShadow: '1px 1px 2px #000',
                        zIndex: 5,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        padding: '2px 4px',
                        borderRadius: '3px'
                    }}>
                        {this.sliceIndex + 1}/{this.sliceMax}
                    </div>
                )}
                {errorOnOpenImage ? (
                    <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                        <Typography variant="body2" color="error">
                            {errorOnOpenImage}
                        </Typography>
                    </div>
                ) : null}
                {progress ? (
                    <div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
                        <CircularProgress size={24} />
                    </div>
                ) : null}
            </div>
        )
    }
  }
  
const mapStateToProps = (state) => {
  return {
    files: state.files,
    series: state.series,
    url: state.url,
    tool: state.tool,
    activeDcmIndex: state.activeDcmIndex,
    activeDcm: state.activeDcm,
    explorerActiveSeriesIndex: state.explorerActiveSeriesIndex,
    measurements: state.measurements,
    fsCurrentDir: state.fsCurrentDir,
    fsCurrentList: state.fsCurrentList,
    dcmEnableTool: state.dcmEnableTool,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    clearingStore: () => dispatch(clearStore()),
    setIsOpenStore: (value) => dispatch(dcmIsOpen(value)),
    toolStore: (tool) => dispatch(dcmTool(tool)),
    setActiveDcm: (dcm) => dispatch(activeDcm(dcm)),
    setActiveMeasurements: (measurements) => dispatch(activeMeasurements(measurements)),
    makeFsRefresh: (dcm) => dispatch(doFsRefresh()),
    setDcmEnableToolStore: (value) => dispatch(setDcmEnableTool(value))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DicomPreviewer)
